<div class="component-content">
  <div class="master">
    <app-task-header></app-task-header>
    <app-tasks-list></app-tasks-list>
  </div>
  <div class="details">
    <app-details-empty *ngIf="!showDetails"
      [primaryText]="'You have not chosen any Task.'"
      [secondaryText]="'Please choose a task, using the list on the left, in order to display more details and options.'">
    </app-details-empty>
    <app-task-details *ngIf="showDetails" (taskDeleted)="hideDetails()"></app-task-details>
  </div>
</div>